import { oz } from '@weft/utils';
import { CurrencySchema } from '../../primitives';

export const MeasuredPriceSchema = oz.object({
  price: oz.number(),
  currency: CurrencySchema,
  units: oz.number(),
  billableUnits: oz.number(),
  nonBillableUnits: oz.number(),
});

export type MeasuredPrice = oz.infer<typeof MeasuredPriceSchema>;